import React from "react";
import { Icon } from "semantic-ui-react";
import "./CircularIcon.scss";

export const CircularIcon = (props: any) => {
  const { displayIcon, active, type = "icon" } = props;
  return (
    <div
      style={{
        minHeight: 36,
        minWidth: 36,
        paddingLeft: 3,
        backgroundColor: active
          ? "#007AC6"
          : type === "skipped"
          ? "lightgrey"
          : type === "completed"
          ? "#067E30"
          : type === "rejected"
          ? "#E4002B"
          : "rgba(0,0,0,0.5)",
        borderRadius: 360,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {type === "icon" && displayIcon}
      {type === "number" && (
        <span aria-hidden='true' className='header-2 white-number tw-mb-0'>
          {displayIcon}
        </span>
      )}
      {type === "skipped" && <Icon size='large' inverted name='minus' color='black' />}
      {type === "completed" && <Icon size='large' inverted name='checkmark' style={{ color: "white" }} />}
      {type === "rejected" && <Icon size='large' inverted name='close' style={{ color: "white" }} />}
    </div>
  );
};
